module.exports = __webpack_public_path__ + "static/media/mandelbrot_fullset.cbd251e7.jpg";